const filterViewsCompany = {
  '61808000-5': {
    general: {
      filtrosHabilitados: [
        {
          nombre: 'Tipo Documento Repositorio',
          campo: 'tipoDocumentoCodigo',
          tipo: 'opcionDocRepo'
        },
      ]
    }
  },
  '61221000-4': {
    general: {
      filtrosFijos: [
        {
          nombre: 'Es privado',
          campo: 'privado', // es privado
          tipo: 'text',
          valor: 'N'
        }
      ],
      filtrosHabilitados: [
        {
          nombre: 'Tipo Documento Repositorio',
          campo: 'tipoDocumentoCodigo',
          tipo: 'opcionDocRepo'
        },
      ]
    }
  },
  '72235100-2': {
    general: {
      filtrosFijos: [
        {
          nombre: 'Es privado',
          campo: 'privado', // es privado
          tipo: 'text',
          valor: 'N'
        }
      ],
      filtrosHabilitados: [
        {
          nombre: 'Tipo Documento Repositorio',
          campo: 'tipoDocumentoCodigo',
          tipo: 'opcionDocRepo'
        },
      ]
    }
  },
  '76172595-5': {
    general: {
      filtrosFijos: [
        {
          nombre: 'Aplicación',
          campo: 'app',
          tipo: 'text',
          valor: 'FEB,ED'
        },
      ]
    },
    entrada: {
      filtrosFijos: [
        {
          nombre: 'Aplicación',
          campo: 'app',
          tipo: 'text',
          valor: 'FEB,ED'
        },
      ]
    },
    salida: {
      filtrosFijos: [
        {
          nombre: 'Aplicación',
          campo: 'app',
          tipo: 'text',
          valor: 'FEB,ED'
        },
      ]
    },
    'entrada-jefatura': {
      filtrosFijos: [
        {
          nombre: 'Aplicación',
          campo: 'app',
          tipo: 'text',
          valor: 'FEB,ED'
        },
      ]
    },
    'pre-oficina': {
      filtrosFijos: [
        {
          nombre: 'Aplicación',
          campo: 'app',
          tipo: 'text',
          valor: 'FEB,ED'
        },
      ]
    },
    enviados: {
      filtrosFijos: [
        {
          nombre: 'Aplicación',
          campo: 'app',
          tipo: 'text',
          valor: 'FEB,ED'
        },
      ]
    },
    'tramitar-numerar': {
      filtrosFijos: [
        {
          nombre: 'Aplicación',
          campo: 'app',
          tipo: 'text',
          valor: 'FEB,ED'
        },
      ]
    },
  },
  '61980520-8': {
    general: {
      filtrosHabilitados: [
        {
          nombre: 'Tipo Documento Repositorio',
          campo: 'tipoDocumentoCodigo',
          tipo: 'opcionDocRepo'
        },
      ]
    },
    entrada: {
      filtrosHabilitados: [
        {
          nombre: 'Modalidad de flujo',
          campo: 'desatendida',
          tipo: 'multi',
          opciones: {
            1: 'Flujo desatendido',
            0: 'Flujo atendido',
          }
        },
        {
          nombre: 'Tipo de paso',
          campo: 'resp_tipo',
          tipo: 'multi',
          opciones: {
            1: 'grupo',
            2: 'usuario',
          }
        },
        {
          nombre: 'Tipo Documento en trámite',
          campo: 'tipoDocumentoId',
          tipo: 'opcionDoc'
        },
        {
          nombre: 'Usuario en flujo',
          campo: 'resp_responsableId',
          tipo: 'usuarioIds'
        },
        {
          nombre: 'Tipo Documento Repositorio',
          campo: 'tipoDocumentoCodigo',
          tipo: 'opcionDocRepo'
        },
      ]
    },
    salida: {
      filtrosHabilitados: [
        {
          nombre: 'Modalidad de flujo',
          campo: 'desatendida',
          tipo: 'multi',
          opciones: {
            1: 'Flujo desatendido',
            0: 'Flujo atendido',
          }
        },
        {
          nombre: 'Tipo Documento en trámite',
          campo: 'tipoDocumentoId',
          tipo: 'opcionDoc'
        },
        {
          nombre: 'Tipo de paso',
          campo: 'resp_tipo',
          tipo: 'multi',
          opciones: {
            1: 'grupo',
            2: 'usuario',
            3: 'Externo',
            6: 'Oficina',
            7: 'Oficial'
          }
        },
        {
          nombre: 'Usuario en flujo',
          campo: 'resp_responsableId',
          tipo: 'usuarioIds'
        },
        {
          nombre: 'Tipo Documento Repositorio',
          campo: 'tipoDocumentoCodigo',
          tipo: 'opcionDocRepo'
        },
      ]
    },
    enviados: {
      filtrosHabilitados: [
        {
          nombre: 'Modalidad de flujo',
          campo: 'desatendida',
          tipo: 'multi',
          opciones: {
            1: 'Flujo desatendido',
            0: 'Flujo atendido',
          }
        },
        {
          nombre: 'Tipo Documento en trámite',
          campo: 'tipoDocumentoId',
          tipo: 'opcionDoc'
        },
        {
          nombre: 'Tipo de paso',
          campo: 'resp_tipo',
          tipo: 'multi',
          opciones: {
            1: 'grupo',
            2: 'usuario',
            3: 'Externo',
            6: 'Oficina',
            7: 'Oficial'
          }
        },
        {
          nombre: 'Usuario en flujo',
          campo: 'resp_responsableId',
          tipo: 'usuarioIds'
        },
        {
          nombre: 'Tipo Documento Repositorio',
          campo: 'tipoDocumentoCodigo',
          tipo: 'opcionDocRepo'
        },
      ]
    }
  }
};
const filterViews = {

  entrada: {
    filtrosFijos: [
      {
        nombre: 'Tipo bandeja',
        campo: 'bandejaTipo',
        tipo: 'text',
        valor: 'entrada'
      },
      {
        nombre: 'Aplicación',
        campo: 'app',
        tipo: 'text',
        valor: 'FEB,ED'
      },
      {
        nombre: 'Tipo responsable',
        campo: 'resp_tipo',
        tipo: 'multi',
        opciones: {
          1: 'grupo',
          2: 'usuario'
        }
      },
    ],
    filtrosHabilitados: [
      {
        nombre: 'Enviado por',
        campo: 'usuarioId',
        tipo: 'usuarioIds'
      },
      {
        nombre: 'Número',
        campo: 'numero',
        tipo: 'texto'
      },
      {
        nombre: 'Número de documento',
        campo: 'numeroReferencia',
        tipo: 'texto'
      },
      {
        nombre: 'Unidad del autor',
        campo: 'unidad',
        tipo: 'grupoIds'
      },
      {
        nombre: 'Oficina del autor',
        campo: 'unidad',
        tipo: 'oficinaIds'
      },
      {
        nombre: 'Nombre de flujo',
        campo: 'nombre',
        tipo: 'texto'
      },
      {
        nombre: 'Tipo Documento en flujo',
        campo: 'tipoObjetoId',
        tipo: 'multi',
        opciones: {
          EXP: 'Expediente',
          'ARCHIVO-RP': 'Archivo Repositorio',
          ARCHIVO: 'Archivo'
        }
      },
      {
        nombre: 'Folio',
        campo: 'folio',
        tipo: 'texto'
      }
    ]
  },
  observador: {
    filtrosFijos: [
      {
        nombre: 'Tipo bandeja',
        campo: 'bandejaTipo',
        tipo: 'text',
        valor: 'observador'
      },
      {
        nombre: 'Aplicación',
        campo: 'app',
        tipo: 'text',
        valor: 'FEB,ED'
      },
      {
        nombre: 'Tipo responsable',
        campo: 'resp_tipo',
        tipo: 'multi',
        opciones: {
          1: 'grupo',
          2: 'usuario'
        }
      },
    ],
    filtrosHabilitados: [
      {
        nombre: 'Enviado por',
        campo: 'usuarioId',
        tipo: 'usuarioIds'
      },
      {
        nombre: 'Número',
        campo: 'numero',
        tipo: 'texto'
      },
      {
        nombre: 'Número de documento',
        campo: 'numeroReferencia',
        tipo: 'texto'
      },
      {
        nombre: 'Unidad del autor',
        campo: 'unidad',
        tipo: 'grupoIds'
      },
      {
        nombre: 'Oficina del autor',
        campo: 'unidad',
        tipo: 'oficinaIds'
      },
      {
        nombre: 'Nombre de flujo',
        campo: 'nombre',
        tipo: 'texto'
      },
      {
        nombre: 'Tipo Documento en flujo',
        campo: 'tipoObjetoId',
        tipo: 'multi',
        opciones: {
          EXP: 'Expediente',
          'ARCHIVO-RP': 'Archivo Repositorio',
          ARCHIVO: 'Archivo'
        }
      },
      {
        nombre: 'Folio',
        campo: 'folio',
        tipo: 'texto'
      }
    ]
  },
  masiva: {
    filtrosFijos: [
      {
        nombre: 'Tipo bandeja',
        campo: 'bandejaTipo',
        tipo: 'text',
        valor: 'entrada'
      },
      {
        nombre: 'Aplicación',
        campo: 'app',
        tipo: 'text',
        valor: 'FEB,ED'
      },
      {
        nombre: 'Tipo proceso',
        campo: 'masiva',
        tipo: 'text',
        valor: 'Y'
      },
    ],
    filtrosHabilitados: [
      {
        nombre: 'Enviado por',
        campo: 'usuarioId',
        tipo: 'usuarioIds'
      },
      {
        nombre: 'Número',
        campo: 'numero',
        tipo: 'texto'
      },
      {
        nombre: 'Número de documento',
        campo: 'numeroReferencia',
        tipo: 'texto'
      },
      {
        nombre: 'Unidad del autor',
        campo: 'unidad',
        tipo: 'grupoIds'
      },
      {
        nombre: 'Oficina del autor',
        campo: 'unidad',
        tipo: 'oficinaIds'
      },
      {
        nombre: 'Nombre de flujo',
        campo: 'nombre',
        tipo: 'texto'
      },
      {
        nombre: 'Tipo Documento en flujo',
        campo: 'tipoObjetoId',
        tipo: 'multi',
        opciones: {
          EXP: 'Expediente',
          'ARCHIVO-RP': 'Archivo Repositorio',
          ARCHIVO: 'Archivo'
        }
      }
    ]
  },
  'entrada-movil': {
    filtrosFijos: [
      {
        nombre: 'Tipo bandeja',
        campo: 'bandejaTipo',
        tipo: 'text',
        valor: 'entrada-movil'
      },
      {
        nombre: 'Aplicación',
        campo: 'app',
        tipo: 'text',
        valor: 'FEB,ED'
      },
      {
        nombre: 'Tipo responsable',
        campo: 'resp_tipo',
        tipo: 'multi',
        opciones: {
          1: 'grupo',
          2: 'usuario'
        }
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Enviado por',
        campo: 'usuarioId',
        tipo: 'usuarioIds'
      },
      {
        nombre: 'Número',
        campo: 'numero',
        tipo: 'texto'
      },
      {
        nombre: 'Número de documento',
        campo: 'numeroReferencia',
        tipo: 'texto'
      },
      {
        nombre: 'Unidad del autor',
        campo: 'unidad',
        tipo: 'grupoIds'
      },
      {
        nombre: 'Oficina del autor',
        campo: 'unidad',
        tipo: 'oficinaIds'
      },
      {
        nombre: 'Nombre de flujo',
        campo: 'nombre',
        tipo: 'texto'
      },
      {
        nombre: 'Tipo Documento en flujo',
        campo: 'tipoObjetoId',
        tipo: 'multi',
        opciones: {
          EXP: 'Expediente',
          'ARCHIVO-RP': 'Archivo Repositorio',
          ARCHIVO: 'Archivo'
        }
      }
    ]
  },
  'entrada-jefatura': {
    filtrosFijos: [
      {
        nombre: 'Tipo bandeja',
        campo: 'bandejaTipo',
        tipo: 'text',
        valor: 'entrada-jefatura'
      },
      {
        nombre: 'Aplicación',
        campo: 'app',
        tipo: 'text',
        valor: 'FEB,ED'
      },
      {
        nombre: 'Tipo responsable',
        campo: 'resp_tipo',
        tipo: 'multi',
        opciones: {
          1: 'grupo',
          2: 'usuario'
        }
      },
    ],
    filtrosHabilitados: [
      {
        nombre: 'Enviado por',
        campo: 'usuarioId',
        tipo: 'usuarioIds'
      },
      {
        nombre: 'Número',
        campo: 'numero',
        tipo: 'texto'
      },
      {
        nombre: 'Número de documento',
        campo: 'numeroReferencia',
        tipo: 'texto'
      },
      {
        nombre: 'Unidad del autor',
        campo: 'unidad',
        tipo: 'grupoIds'
      },
      {
        nombre: 'Oficina del autor',
        campo: 'unidad',
        tipo: 'oficinaIds'
      },
      {
        nombre: 'Nombre de flujo',
        campo: 'nombre',
        tipo: 'texto'
      },
      {
        nombre: 'Tipo Documento en flujo',
        campo: 'tipoObjetoId',
        tipo: 'multi',
        opciones: {
          EXP: 'Expediente',
          'ARCHIVO-RP': 'Archivo Repositorio',
          ARCHIVO: 'Archivo'
        }
      },
      {
        nombre: 'Folio',
        campo: 'folio',
        tipo: 'texto'
      }
    ]
  },
  salida: {
    filtrosFijos: [
      {
        nombre: 'Tipo bandeja',
        campo: 'bandejaTipo',
        tipo: 'text',
        valor: 'salida'
      },
      {
        nombre: 'Aplicación',
        campo: 'app',
        tipo: 'text',
        valor: 'FEB,ED'
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Enviado por',
        campo: 'usuarioId',
        tipo: 'usuarioIds'
      },
      {
        nombre: 'Número',
        campo: 'numero',
        tipo: 'texto'
      },
      {
        nombre: 'Número de documento',
        campo: 'numeroReferencia',
        tipo: 'texto'
      },
      {
        nombre: 'Unidad del autor',
        campo: 'unidad',
        tipo: 'grupoIds'
      },
      {
        nombre: 'Oficina del autor',
        campo: 'unidad',
        tipo: 'oficinaIds'
      },
      {
        nombre: 'Nombre de flujo',
        campo: 'nombre',
        tipo: 'texto'
      },
      {
        nombre: 'Tipo Documento en flujo',
        campo: 'tipoObjetoId',
        tipo: 'multi',
        opciones: {
          EXP: 'Expediente',
          'ARCHIVO-RP': 'Archivo Repositorio',
          ARCHIVO: 'Archivo'
        }
      },
      {
        nombre: 'Estado',
        campo: 'aprobacionesEjecucionEstadoId',
        tipo: 'multi',
        opciones: {
          1: 'Desestimado',
          3: 'Iniciado',
          4: 'Aprobado',
          5: 'Rechazado',
          6: 'Anulado'
        }
      },
      {
        nombre: 'Folio',
        campo: 'folio',
        tipo: 'texto'
      }
    ]
  },
  general: {
    filtrosFijos: [
      {
        nombre: 'Tipo bandeja',
        campo: 'bandejaTipo',
        tipo: 'text',
        valor: 'general'
      },
    ],
    filtrosHabilitados: [
      {
        nombre: 'Enviado por',
        campo: 'usuarioId',
        tipo: 'usuarioIds'
      },
      {
        nombre: 'Número',
        campo: 'numero',
        tipo: 'texto'
      },
      {
        nombre: 'Número de documento',
        campo: 'numeroReferencia',
        tipo: 'texto'
      },
      {
        nombre: 'Usuario en flujo',
        campo: 'resp_responsableId',
        tipo: 'usuarioIds'
      },
      {
        nombre: 'Tipo de paso',
        campo: 'resp_tipo',
        tipo: 'multi',
        opciones: {
          1: 'grupo',
          2: 'usuario',
          3: 'Externo',
          6: 'Oficina',
          7: 'Oficial'
        }
      },
      {
        nombre: 'Unidad del autor',
        campo: 'unidad',
        tipo: 'grupoIds'
      },
      {
        nombre: 'Oficina del autor',
        campo: 'unidad',
        tipo: 'oficinaIds'
      },
      {
        nombre: 'Nombre de flujo',
        campo: 'nombre',
        tipo: 'texto'
      },
      {
        nombre: 'Tipo Documento en flujo',
        campo: 'tipoObjetoId',
        tipo: 'multi',
        opciones: {
          EXP: 'Expediente',
          'ARCHIVO-RP': 'Archivo Repositorio',
          ARCHIVO: 'Archivo'
        }
      },
      {
        nombre: 'Tipo Documento en trámite',
        campo: 'tipoDocumentoId',
        tipo: 'opcionDoc'
      },
      {
        nombre: 'Estado',
        campo: 'aprobacionesEjecucionEstadoId',
        tipo: 'multi',
        opciones: {
          1: 'Desestimado',
          2: 'Preparado',
          3: 'Iniciado',
          4: 'Aprobado',
          5: 'Rechazado',
          6: 'Anulado'
        }
      },
      {
        nombre: 'Modalidad de flujo',
        campo: 'desatendida',
        tipo: 'multi',
        opciones: {
          1: 'Flujo desatendido',
          0: 'Flujo atendido',
        }
      },
      {
        nombre: 'Folio',
        campo: 'folio',
        tipo: 'texto'
      }
    ]
  },
  'pre-oficina': {
    filtrosFijos: [
      {
        nombre: 'Tipo bandeja',
        campo: 'bandejaTipo',
        tipo: 'text',
        valor: 'oficina'
      },
      {
        nombre: 'Tipo responsable',
        campo: 'resp_tipo',
        tipo: 'multi',
        opciones: {
          6: 'Oficina',
          7: 'Oficial'
        }
      },
      {
        nombre: 'Estado',
        campo: 'aprobacionesEjecucionEstadoId',
        tipo: 'text',
        valor: '3'
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Enviado por',
        campo: 'usuarioId',
        tipo: 'usuarioIds'
      },
      {
        nombre: 'Número',
        campo: 'numero',
        tipo: 'texto'
      },
      {
        nombre: 'Número de documento',
        campo: 'numeroReferencia',
        tipo: 'texto'
      },
      {
        nombre: 'Unidad del autor',
        campo: 'unidad',
        tipo: 'grupoIds'
      },
      {
        nombre: 'Oficina del autor',
        campo: 'unidad',
        tipo: 'oficinaIds'
      },
      {
        nombre: 'Nombre de flujo',
        campo: 'nombre',
        tipo: 'texto'
      },
      {
        nombre: 'Tipo Documento en flujo',
        campo: 'tipoObjetoId',
        tipo: 'multi',
        opciones: {
          EXP: 'Expediente',
          'ARCHIVO-RP': 'Archivo Repositorio',
          ARCHIVO: 'Archivo'
        }
      },
      {
        nombre: 'Tipo Documento en trámite',
        campo: 'tipoDocumentoId',
        tipo: 'opcionDoc'
      },
      {
        nombre: 'Folio',
        campo: 'folio',
        tipo: 'texto'
      }
    ]
  },
  enviados: {
    filtrosFijos: [
      {
        nombre: 'Tipo bandeja',
        campo: 'bandejaTipo',
        tipo: 'text',
        valor: 'general'
      },
      {
        nombre: 'Enviado por',
        campo: 'usuarioId',
        tipo: 'text',
        // eslint-disable-next-line no-template-curly-in-string
        valor: '${idUsuario}'
      },
    ],
    filtrosHabilitados: [
      {
        nombre: 'Número',
        campo: 'numero',
        tipo: 'texto'
      },
      {
        nombre: 'Número de documento',
        campo: 'numeroReferencia',
        tipo: 'texto'
      },
      {
        nombre: 'Unidad del autor',
        campo: 'unidad',
        tipo: 'grupoIds'
      },
      {
        nombre: 'Oficina del autor',
        campo: 'unidad',
        tipo: 'oficinaIds'
      },
      {
        nombre: 'Nombre de flujo',
        campo: 'nombre',
        tipo: 'texto'
      },
      {
        nombre: 'Tipo Documento en flujo',
        campo: 'tipoObjetoId',
        tipo: 'multi',
        opciones: {
          EXP: 'Expediente',
          'ARCHIVO-RP': 'Archivo Repositorio',
          ARCHIVO: 'Archivo'
        }
      },
      {
        nombre: 'Estado',
        campo: 'aprobacionesEjecucionEstadoId',
        tipo: 'multi',
        opciones: {
          1: 'Desestimado',
          3: 'Iniciado',
          4: 'Aprobado',
          5: 'Rechazado',
          6: 'Anulado'
        }
      },
      {
        nombre: 'Folio',
        campo: 'folio',
        tipo: 'texto'
      }
    ]
  },
  'tramitar-numerar': {
    filtrosFijos: [
      {
        nombre: 'Tipo bandeja',
        campo: 'bandejaTipo',
        tipo: 'text',
        valor: 'oficina'
      },
      {
        nombre: 'Tipo responsable',
        campo: 'resp_tipo',
        tipo: 'multi',
        opciones: {
          7: 'Oficial'
        }
      },
      {
        nombre: 'Estado',
        campo: 'aprobacionesEjecucionEstadoId',
        tipo: 'text',
        valor: '3'
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Enviado por',
        campo: 'usuarioId',
        tipo: 'usuarioIds'
      },
      {
        nombre: 'Número',
        campo: 'numero',
        tipo: 'texto'
      },
      {
        nombre: 'Número de documento',
        campo: 'numeroReferencia',
        tipo: 'texto'
      },
      {
        nombre: 'Unidad del autor',
        campo: 'unidad',
        tipo: 'grupoIds'
      },
      {
        nombre: 'Oficina del autor',
        campo: 'unidad',
        tipo: 'oficinaIds'
      },
      {
        nombre: 'Nombre de flujo',
        campo: 'nombre',
        tipo: 'texto'
      },
      {
        nombre: 'Tipo Documento en flujo',
        campo: 'tipoObjetoId',
        tipo: 'multi',
        opciones: {
          EXP: 'Expediente',
          'ARCHIVO-RP': 'Archivo Repositorio',
          ARCHIVO: 'Archivo'
        }
      },
      {
        nombre: 'Tipo Documento en trámite',
        campo: 'tipoDocumentoId',
        tipo: 'opcionDoc'
      },
      {
        nombre: 'Folio',
        campo: 'folio',
        tipo: 'texto'
      }
    ]
  }

};

export default {
  data() {
    return filterViews;
  },
  methods: {
    getFilterView(view, iutCompany) {
      let filtros = { ...filterViews[view] };
      if (filterViewsCompany[iutCompany] && filterViewsCompany[iutCompany][view]) {
        filtros = {
          filtrosFijos: [
            ...filterViewsCompany[iutCompany][view].filtrosFijos || [],
            ...filtros.filtrosFijos || []
          ],
          filtrosHabilitados: [
            ...filterViewsCompany[iutCompany][view].filtrosHabilitados || [],
            ...filtros.filtrosHabilitados || []
          ]
        };
        console.log('???', filterViewsCompany[iutCompany][view].filtrosHabilitados);
        if (filterViewsCompany[iutCompany][view].filtroFijoABorrar) {
          filtros = {
            ...filtros,
            filtrosFijos: filtros.filtrosFijos.filter(
              (filtro) => !filterViewsCompany[iutCompany][view].filtroFijoABorrar
                .includes(filtro.campo)
            )
          };
        }
      }
      if (filterViewsCompany[iutCompany] && filterViewsCompany[iutCompany].renombres) {
        const { renombres } = filterViewsCompany[iutCompany];
        Object.keys(renombres).forEach((key) => {
          /* eslint-disable no-unused-expressions */
          filtros.filtrosHabilitados?.forEach((filtro) => {
            if (filtro.campo === key) {
              /* eslint-disable no-param-reassign */
              filtro.nombre = renombres[key];
            }
          });
        });
      }
      return filtros;
    }
  }
};
